var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('Loading',{attrs:{"isLoading":_vm.isCurrentUserLoading}},[_c('PageHeader',{attrs:{"title":_vm.welcome(),"subtitle":"Your Dashboard Overview"}}),_c('homepage-layout')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }